/**
 * Storage-abuse limits. Single source of truth for the client and Cloud
 * Functions. The per-user cap is enforced in `functions/src/compressImage.ts`
 * (Storage rules cannot cross-service read Firestore counters in production);
 * `storage.rules` mirrors only MAX_UPLOAD_BYTES as a literal.
 */

/** Per-item photo cap (client UX guard). */
export const MAX_IMAGES_PER_ITEM = 8;

/** Per-user photo cap — enforced by the Storage-triggered function. */
export const MAX_IMAGES_PER_USER = 500;

/** Per-file upload ceiling (bytes). The client compresses to ~1.2MB first, so
 *  real users never approach this; it only bounds a client-bypasser. */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

/** Global storage ceiling (bytes). When crossed, the functions flip the
 *  `system/config.uploadsEnabled` kill-switch and Storage rules deny uploads. */
export const GLOBAL_STORAGE_CEILING_BYTES = 20 * 1024 * 1024 * 1024;
